// extracted by mini-css-extract-plugin
export var blogBlock = "recentBlog-module--blog-block--a67e5";
export var blogTitle = "recentBlog-module--blog-title--43802";
export var blogs = "recentBlog-module--blogs--4a536";
export var category = "recentBlog-module--category--c0f8a";
export var container = "recentBlog-module--container--89453";
export var heading = "recentBlog-module--heading--cbc9b";
export var subheading = "recentBlog-module--subheading--1c88e";
export var subtitle = "recentBlog-module--subtitle--26e6a";
export var textBox = "recentBlog-module--text-box--2ad3a";
export var textBoxOverlay = "recentBlog-module--text-box-overlay--ebd19";
export var thumbnail = "recentBlog-module--thumbnail--0ac0b";
export var thumbnailBlock = "recentBlog-module--thumbnail-block--4b551";
export var thumbnailOverlay = "recentBlog-module--thumbnail-overlay--70512";